<template>
    <!-- Add Shipping Modal -->
    <div
        class="modal fade"
        id="shippingTrackingModal1"
        ref="shippingTrackingModal1"
        tabindex="-1"
        aria-labelledby="shippingModalLabel1"
        aria-hidden="true"
    >
        <div
            class="modal-dialog modal-dialog-centered modal-lg"
            style="max-width: 900px"
        >
            <div class="modal-content border-0">
                <div class="modal-header p-3 bg-soft-info">
                    <h5 class="modal-title" id="shippingModalLabel1">
                        Shipping Details
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>
                <div class="modal-body">
                    <div class="invoiceDetails table-responsive">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>Eta</th>
                                    <th>Etd</th>
                                    <th>Location From</th>
                                    <th>Location To</th>
                                    <th>Mode</th>
                                    <th>Type</th>
                                    <th>Carrier Name</th>
                                    <th>Confirmed</th>
                                    <th>Agent</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="shipmentDetails.length > 0">
                                    <template
                                        v-for="(
                                            shipment, index
                                        ) in shipmentDetails"
                                    >
                                        <tr>
                                            <td>{{ shipment.eta }}</td>
                                            <td>{{ shipment.etd }}</td>
                                            <td>
                                                {{ shipment.location_from }}
                                            </td>
                                            <td>{{ shipment.location_to }}</td>
                                            <td>{{ shipment.mode }}</td>
                                            <td>{{ shipment.type }}</td>
                                            <td>{{ shipment.carrier_name }}</td>
                                            <td>
                                                {{
                                                    shipment.is_confirmed == 1
                                                        ? "Yes"
                                                        : "No"
                                                }}
                                            </td>
                                            <td>{{ shipment.agent }}</td>
                                        </tr>
                                    </template>
                                </template>
                                <template v-else> No Data found </template>
                            </tbody>
                        </table>
                    </div>

                    <div class="invoiceDetails table-responsive">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>Order Number</th>
                                    <th colspan="11"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="shippingOrderItems.length > 0">
                                    <template
                                        v-for="(
                                            shipment, index
                                        ) in shippingOrderItems"
                                    >
                                        <tr>
                                            <td>
                                                {{ shipment.order_number }}
                                            </td>
                                            <td colspan="11"></td>
                                        </tr>
                                        <tr>
                                            <th>SKU</th>
                                            <th>Classification Code</th>
                                            <th>
                                                Product Classification
                                                Description
                                            </th>
                                            <th>Description</th>
                                            <th>Unship Cartons</th>
                                            <th>Carton</th>
                                            <th>Unit Price</th>
                                            <th>Amount</th>
                                            <th>Units Per Carton</th>
                                            <th>Units</th>
                                            <th>Volume</th>
                                            <th>Weight</th>
                                        </tr>
                                        <template
                                            v-for="(
                                                product, index
                                            ) in shipment.products"
                                        >
                                            <tr>
                                                <td>{{ product.sku }}</td>
                                                <td>
                                                    {{
                                                        product.classification_code
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        product.product_classification_description
                                                    }}
                                                </td>
                                                <td>
                                                    {{ product.description }}
                                                </td>
                                                <td>
                                                    {{ product.unship_cartons }}
                                                </td>
                                                <td>
                                                    {{ product.carton }}
                                                </td>
                                                <td>
                                                    {{ product.unit_price }}
                                                </td>
                                                <td>
                                                    {{ product.amount }}
                                                </td>
                                                <td>
                                                    {{
                                                        product.units_per_carton
                                                    }}
                                                </td>
                                                <td>{{ product.units }}</td>
                                                <td>
                                                    {{ product.volume }}
                                                </td>
                                                <td>
                                                    {{ product.weight }}
                                                </td>
                                            </tr>
                                        </template>
                                        <!-- <td>{{ shipment.etd }}</td>
                                            <td>
                                                {{ shipment.location_from }}
                                            </td>
                                            <td>{{ shipment.location_to }}</td>
                                            <td>{{ shipment.mode }}</td>
                                            <td>{{ shipment.type }}</td>
                                            <td>{{ shipment.carrier_name }}</td>
                                            <td>
                                                {{
                                                    shipment.is_confirmed == 1
                                                        ? "Yes"
                                                        : "No"
                                                }}
                                            </td>
                                            <td>{{ shipment.agent }}</td> -->
                                        <!-- </tr> -->
                                    </template>
                                </template>
                                <template v-else> No Data found </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
    name: "ShippingTrackingModal",
    props: [
        "shipping",
        "order",
        "loading",
        "carriers",
        "shippingByRef",
        "shippingStatus",
        "shipmentDetails",
        "shippingOrderItems",
    ],
    components: {},
    created() {},
    mounted() {
        let self = this;

        $("#shippingTrackingModal").on("show.bs.modal", () => {});

        $(this.$refs.shippingTrackingModal).on(
            "hidden.bs.modal",
            function () {}
        );
    },
    data() {
        return {};
    },
    methods: {
        ...mapActions([
            "setCommonErrors",
            "setErrorMessage",
            "setSuccessMessage",
            "setLoading",
        ]),
    },
    computed: {
        ...mapGetters(["commonErrors", "errorMessage", "successMessage"]),
    },
    watch: {},
};
</script>

<style scoped></style>
